export const isDisabled = (formState, formAction) => {
    return getDisabledActions(formState).includes(formAction);
};

const submittingDisabledActions = ['submit', 'cancel', 'new', 'edit', 'remove'];
const dirtyDisabledActions = ['submit'];
const noDisabledActions = [];

function getDisabledActions(formState) {
    if (formState.submitting) {
        return submittingDisabledActions;
    }
    if (!formState.isDirty) {
        return dirtyDisabledActions;
    }
    return noDisabledActions;
}
